<template>
    <!-- 支付阶段 -->
    <div class="bid-box">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="width:100%;height:100%;">
            <el-tab-pane label="项目施工类" name="first">
                <el-table
                    :data="listData"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位类型">
                        <template slot-scope="scope">
                            <span>{{ scope.row.unitTypeName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.contractName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同编号">
                        <template slot-scope="scope">
                            <span>{{ scope.row.serialNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同价（万元）">
                        <template slot-scope="scope">
                            <span>{{ scope.row.contractPrice }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="累计审定产值（万元）" width="220">
                        <template slot-scope="scope">
                           <span v-if="scope.row.first.total0 && scope.row.first.total0==0">{{ scope.row.first.total0 }}</span>
                           <span v-else @click="toDetail(scope.row)" style="color:#1299F3;cursor: pointer;">{{ scope.row.first.total0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="累计工程款支付（万元）" width="260">
                        <template slot-scope="scope">
                            <span v-if="scope.row.first.total2 && scope.row.first.total2==0">{{ scope.row.first.total2 }}</span>
                            <span v-else @click="toDetail(scope.row)" style="color:#1299F3;cursor: pointer;">{{ scope.row.first.total2 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="累计农民工专户支付（万元）" width="300">
                        <template slot-scope="scope">
                            <span v-if="scope.row.first.total3 && scope.row.first.total3==0">{{ scope.row.first.total3 }}</span>
                            <span v-else @click="toDetail(scope.row)" style="color:#1299F3;cursor: pointer;">{{ scope.row.first.total3 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="违约金（万元）">
                        <template slot-scope="scope">
                            <span v-if="scope.row.first.total4 && scope.row.first.total4==0">{{ scope.row.first.total4 }}</span>
                            <span v-else @click="toDetail(scope.row)" style="color:#1299F3;cursor: pointer;">{{ scope.row.first.total4 }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="管理服务类" name="second">
                <el-table
                    :data="listData1"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText1}}</p>
                    </template>
                    <el-table-column label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位类型">
                        <template slot-scope="scope">
                            <span>{{ scope.row.unitTypeName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.contractName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同编号">
                        <template slot-scope="scope">
                            <span>{{ scope.row.serialNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同价（万元）">
                        <template slot-scope="scope">
                            <span>{{ scope.row.contractPrice }}</span>
                        </template>
                    </el-table-column>
                   <el-table-column label="累计审定产值（万元）" width="260">
                        <template slot-scope="scope">
                           <span v-if="scope.row.first.total0 && scope.row.first.total0==0">{{ scope.row.first.total0 }}</span>
                           <span v-else @click="toDetail(scope.row)" style="color:#1299F3;cursor: pointer;">{{ scope.row.first.total0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="累计工程款支付（万元）" width="260">
                        <template slot-scope="scope">
                            <span v-if="scope.row.first.total2 && scope.row.first.total2==0">{{ scope.row.first.total2 }}</span>
                            <span v-else @click="toDetail(scope.row)" style="color:#1299F3;cursor: pointer;">{{ scope.row.first.total2 }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="累计农民工专户支付（万元）">
                        <template slot-scope="scope">
                            <span v-if="scope.row.first.total3 && scope.row.first.total3==0">{{ scope.row.first.total3 }}</span>
                            <span v-else @click="toDetail(scope.row)" style="color:#1299F3;cursor: pointer;">{{ scope.row.first.total3 }}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="违约金（万元）">
                        <template slot-scope="scope">
                            <span v-if="scope.row.first.total4 && scope.row.first.total4==0">{{ scope.row.first.total4 }}</span>
                            <span v-else @click="toDetail(scope.row)" style="color:#1299F3;cursor: pointer;">{{ scope.row.first.total4 }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import base from '../../../untils/base'
export default {
    data(){
        return{
            contractId:"",
            id:'',
            groupId:'',
            listData:[],
            listData1:[],
            activeName:'first',
            dataText:'数据加载中...',
            dataText1:'数据加载中...',
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        this.id = params.id
        if(util.session.get('tab')&&util.session.get('tab')!=''){
            this.activeName = util.session.get('tab')
            util.session.remove('tab')
        }
        if(this.activeName=='first'){
            this.getData()
        }else{
            this.getData1()
        }
    },
    methods:{
        //获取项目施工类数据
        getData(){
            var that = this
            myHttp.selectProjectPayList({
                contractId:this.id,
                unitKind:'1'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list
                    for(var i=0;i<list.length;i++){
                        list[i].first = list[i].first?JSON.parse(list[i].first):{total4:0,total0:0,total2:0,total3:0,}
                        list[i].index = (i+1)
                    }
                    that.listData = list
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },
        //获取管理服务类数据1
        getData1(){
            var that = this
            myHttp.selectProjectPayList({
                contractId:this.id,
                unitKind:'2'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list
                    for(var i=0;i<list.length;i++){
                        list[i].first = list[i].first?JSON.parse(list[i].first):{"total4":0,"total0":0,"total2":0,"total3":0,}
                        list[i].index = (i+1)
                    }
                    that.listData1 = list
                    if(list.length==0){
                        that.dataText1 = '暂无数据'
                    }
                }else{
                    that.dataText1 = '暂无数据'
                }
            })
        },
        //切换
        handleClick(e,event){
            if(e.index=='0'){
                this.getData()
            }else{
                this.getData1()
            }
        },
        //进入详情
        toDetail(row){
            util.session.set('tab',this.activeName)
            this.$router.push({path:'/payDetail/'+row.contractId})
        },
    },
}
</script>

<style scoped>
    .bid-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>

<style>
    .el-tabs__content{
        height: calc( 100% - 6vh );
    }
    .el-tab-pane{
        height: 100%;
    }
    .el-tabs__item{
        font-size: inherit;
    }
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>